import axios from 'axios'

export default {
	getUsers (params = {}) {
		return axios.get('/api/user', {
			params: params
		})
      .then((response) => Promise.resolve(response))
      .catch((error) => Promise.reject(error))
	},
	searchUser (search = {}) {
		return axios.get('/api/user', {
			params: search
		})
      .then((response) => Promise.resolve(response))
      .catch((error) => Promise.reject(error))
	},
	getUser (id) {
		return axios.get(`/api/user/${id}`)
      .then((response) => Promise.resolve(response))
      .catch((error) => Promise.reject(error))
	},
	updateUser ({ id, formData }) {
		return axios.post(`/api/user/${id}`, formData)
      .then((response) => Promise.resolve(response))
      .catch((error) => Promise.reject(error))
	}
}



// WEBPACK FOOTER //
// ./src/vuex/api/services/user.js